import { convertFromToUser } from 'utils/users'
import { getIconName as getActivityIconName } from 'utils/activities'
import { createSelector } from 'reselect'

export const getFrom = (state, props) => {
  return props.from
}

export const makeFromUserSelector = () => createSelector(
  [
    getFrom
  ],
  (
    from
  ) =>
    convertFromToUser(from)
)

const getActivities = (state, props) => {
  return props.activities
}

const makeActivityCountsSelector = () => createSelector(
  [
    getActivities
  ],
  (
    activities
  ) => {
    const activityCountsByIconName = activities.reduce((acc, activity) => {
      const iconName = getActivityIconName(activity.data.action)

      if (acc[iconName]) {
        acc[iconName]++
      } else {
        acc[iconName] = 1
      }

      return acc
    }, {})

    return Object.keys(activityCountsByIconName)
      .reduce((acc, iconName) => {
        acc.push({
          count: activityCountsByIconName[iconName],
          iconName
        })

        return acc
      }, [])
  }
)

export default () => {
  const fromUserSelector = makeFromUserSelector()
  const activityCountsSelector = makeActivityCountsSelector()

  return createSelector(
    [
      fromUserSelector,
      activityCountsSelector
    ],
    (
      fromUser,
      activityCounts
    ) => ({
      fromUser,
      activityCounts
    })
  )
}
